/**
 * Allows us to pply on the fly/dynamic field
 * mapping based on a namespace
 * @param {String} namespaceProp
 * @param {Array} fields
 */
export const dynamicFieldMatching = (namespaceProp, fields) => {
    return Object.keys(fields).reduce((prev, key) => {
        const path = fields[key];
        const field = {
            get() {
                const namespace = this[namespaceProp];
                const getterPath = `${namespace}/getField`;
                return this.$store.getters[getterPath](path);
            },
            set(value) {
                const namespace = this[namespaceProp];
                const mutationPath = `${namespace}/updateField`;
                this.$store.commit(mutationPath, { path, value });
            }
        };
        prev[key] = field;
        return prev;
    }, {});
};



// WEBPACK FOOTER //
// ./resources/assets/js/helpers/dynamicFieldMatching.js